import './App.css';
import AppRoutes from './components/Route.tsx';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store.ts';
import MenuBar from './components/common_components/MenuBar.tsx';
import { ToastProvider } from '../src/components/base_components/ToastContext.tsx'; 

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <MenuBar></MenuBar>
          <div>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </div>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
